import { ReactNode } from 'react';

import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import {
  createResourceLinkExtension,
  extractLastNameComponent,
  isResourceName,
} from '@spotify/confidence-core-react';
import { useProjectRef } from '@spotify/plugin-confidence-projects-react';

import { projectsPlugin } from '../plugin';
import { projectRouteRef } from '../routes';

interface ProjectResourceLinkProps {
  name: string;
  text: ReactNode;
  className?: string;
}

const ProjectResourceLink = ({
  name,
  text,
  className,
}: ProjectResourceLinkProps) => {
  const routeRef = useRouteRef(projectRouteRef);
  const projectId = extractLastNameComponent(name);
  const { project } = useProjectRef({ name });

  if (!routeRef || !projectId) {
    return <>{text}</>;
  }

  const to = routeRef({ id: projectId });

  return (
    <Link to={to} className={className}>
      {project?.displayName ?? text}
    </Link>
  );
};

export const ProjectResourceLinkExtension = projectsPlugin.provide(
  createResourceLinkExtension({
    id: 'project-resource-link',
    predicate: ({ name }) => isResourceName(name, 'projects'),
    render: ({ name, text, className }) => (
      <ProjectResourceLink name={name} text={text} className={className} />
    ),
  }),
);
